import { ProviderType } from "./ObjectTypes";

export const v1_technologies: ProviderType[] = [
  {
    name: "Bidtrack",
    id: "",
    value: "bidtrack",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/bidtrack",
    description: "Vehicle Trackers",
    actions: []
  },
  {
    name: "CarTrack",
    id: "",
    value: "cartrack",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/cartrack",
    description: "Vehicle Trackers",
    actions: []
  },
  {
    name: "Ceres Wild",
    id: "",
    value: "ceres-wild",
    help_center_url: "https://support.earthranger.com/en_US/animal-tracking/ceres-wild",
    description: "Animal Collars",
    actions: []
  },
  {
    name: "Druid Technology",
    id: "",
    value: "druid-technology",
    help_center_url: "https://support.earthranger.com/en_US/animal-tracking/druid-technology",
    description: "Animal Collars",
    actions: []
  },
  {
    name: "EarthRanger to EarthRanger",
    id: "",
    value: "er2er",
    help_center_url: "https://support.earthranger.com/en_US/earthranger_conservation_software/er2er",
    description: "Cross-Site Data Sharing",
    actions: []
  },
  {
    name: "EzyTrack",
    id: "",
    value: "ezytrack",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/ezytrack",
    description: "Vehicle Trackers",
    actions: []
  },
  {
    name: "Fargo Tracking, Wells Fargo",
    id: "",
    value: "wells-fargo-tracking",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/wells-fargo-tracking",
    description: "Vehicle Trackers",
    actions: []
  },
  {
    name: "FindMy",
    id: "",
    value: "findmy",
    help_center_url: "https://support.earthranger.com/en_US/animal-tracking/findmy",
    description: "Animal Collars",
    actions: []
  },
  {
    name: "Flow",
    id: "",
    value: "flow-tech-solutions",
    help_center_url: "https://support.earthranger.com/en_US/animal-tracking/flow-tech-solutions",
    description: "Animal Collars",
    actions: []
  },
  {
    name: "Followit",
    id: "",
    value: "followit",
    help_center_url: "https://support.earthranger.com/en_US/animal-tracking/followit",
    description: "Animal Collars",
    actions: []
  },
  {
    name: "Gestfrota",
    id: "",
    value: "gesfrota",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/gesfrota",
    description: "Vehicle Trackers",
    actions: []
  },
  {
    name: "GSatSolar",
    id: "",
    value: "gsatsolar",
    help_center_url: "https://support.earthranger.com/en_US/animal-tracking/gsatsolar",
    description: "Animal Collars",
    actions: []
  },
  {
    name: "ICUServer",
    id: "",
    value: "icuserver",
    help_center_url: "https://support.earthranger.com/en_US/camera-trap/icuserver",
    description: "Camera Traps",
    actions: []
  },
  {
    name: "iTrack",
    id: "",
    value: "itrack",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/itrack",
    description: "Vehicle Trackers",
    actions: []
  },
  {
    name: "iTrackLive",
    id: "",
    value: "itracklive",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/itracklive",
    description: "Vehicle Trackers",
    actions: []
  },
  {
    name: "Kerlink Gateway",
    id: "",
    value: "kerlink",
    help_center_url: "https://support.earthranger.com/en_US/iot/kerlink",
    description: "IoT",
    actions: []
  },
  {
    name: "Liquid Tech",
    id: "",
    value: "liquid-intelligence-technologies",
    help_center_url: "https://support.earthranger.com/en_US/iot/liquid-intelligence-technologies",
    description: "IoT",
    actions: []
  },
  {
    name: "Mireo",
    id: "",
    value: "mireo",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/mireo",
    description: "Vehicle Trackers",
    actions: []
  },
  {
    name: "NamTrack",
    id: "",
    value: "namtrack",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/namtrack",
    description: "Vehicle Trackers",
    actions: []
  },
  {
    name: "NAVSAT",
    id: "",
    value: "navsat",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/navsat",
    description: "Vehicle Trackers",
    actions: []
  },
  {
    name: "OroraTech",
    id: "",
    value: "ororatech",
    help_center_url: "https://support.earthranger.com/en_US/remote-imagery/ororatech",
    description: "Remote Imagery",
    actions: []
  },
  {
    name: "Owley",
    id: "",
    value: "owley",
    help_center_url: "https://support.earthranger.com/en_US/animal-tracking/owley",
    description: "Animal Collars",
    actions: []
  },
  {
    name: "Sigfox",
    id: "",
    value: "sigfox",
    help_center_url: "https://support.earthranger.com/en_US/iot/sigfox",
    description: "IoT",
    actions: []
  },
  {
    name: "SMART to EarthRanger",
    id: "",
    value: "receiving-data-from-smart-connect",
    help_center_url: "https://support.earthranger.com/en_US/smart/receiving-data-from-smart-connect",
    description: "Data Sharing",
    actions: []
  },
  {
    name: "SpoorTrack",
    id: "",
    value: "spoortrack",
    help_center_url: "https://support.earthranger.com/en_US/animal-tracking/spoortrack",
    description: "Animal Collars",
    actions: []
  },
  {
    name: "Traccar",
    id: "",
    value: "traccar",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/traccar",
    description: "Vehicle Trackers",
    actions: []
  },
  {
    name: "Track Solid",
    id: "",
    value: "track-solid",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/track-solid",
    description: "Vehicle Trackers",
    actions: []
  },
  {
    name: "TrackIt",
    id: "",
    value: "trackit",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/trackit",
    description: "Vehicle Trackers",
    actions: []
  },
  {
    name: "Ultimate Tracking",
    id: "",
    value: "ultimate-tracking",
    help_center_url: "https://support.earthranger.com/en_US/vehicle-trackers/ultimate-tracking",
    description: "Vehicle Trackers",
    actions: []
  },
  {
    name: "JVA Eletric Fencing",
    id: "",
    value: "jva",
    help_center_url: "https://support.earthranger.com/en_US/iot/jva",
    description: "IoT",
    actions: []
  },
  {
    name: "Wildlife Computers",
    id: "",
    value: "wildlife-computers",
    help_center_url: "https://support.earthranger.com/en_US/animal-tracking/wildlife-computers",
    description: "Animal Collars",
    actions: []
  }
];
